import React from 'react';
import { ResponsiveLine } from '@nivo/line';
import { curr } from 'helpers/curr';
import dayjs from 'dayjs';
import { DashboardCurrency } from '../dashboardFilters.machine';

const ChartBalanceHistory = ({
  data,
  currency,
}: {
  data: any[];
  currency: DashboardCurrency;
}) => {
  let key: 'aggr_balance_gbp' | 'aggr_balance_usd' | 'aggr_balance_eur' =
    'aggr_balance_gbp';

  if (currency === 'EUR') {
    key = 'aggr_balance_eur';
  } else if (currency === 'USD') {
    key = 'aggr_balance_usd';
  }

  let lowestValue = data.sort((a, b) => a[key] - b[key])[0]?.[key];
  lowestValue = lowestValue - lowestValue * 0.025; // 2.5% lower
  const SIGF = 1000000;

  const dates = data?.sort((a, b) => (a.date < b.date ? 1 : -1));

  const newest = dayjs(dates[0]?.date || undefined);
  const oldest = dayjs(dates[dates.length - 1]?.date || undefined);
  const oldest_balance_age_in_months = newest.diff(oldest, 'month');

  return (
    <div className="flex-grow mb-5 bg-white border border-gray-400 rounded-lg shadow-sm">
      <h2 className="flex items-start justify-between p-5 mb-5 text-xs font-semibold tracking-wider text-gray-700 uppercase bg-gray-100 border-b border-gray-200 rounded-t-lg">
        <span>Balance History</span>
      </h2>
      <div className="m-5 h-96">
        <ResponsiveLine
          data={[
            {
              id: 'Total Balance',
              data: dates?.map((item) => ({
                x: item?.date,
                y: item?.[key],
              })),
            },
          ]}
          theme={{ fontFamily: 'Inter' } as any}
          margin={{ top: 3, right: 5, bottom: 50, left: 5 }}
          enableGridX={true}
          enableGridY={false}
          enableCrosshair={false}
          isInteractive={true}
          enableArea={true}
          enablePoints={true}
          lineWidth={1}
          pointSize={5}
          useMesh={true}
          areaOpacity={0.8}
          colors={['#4299E1']}
          // @ts-ignore
          areaBaselineValue={lowestValue}
          yScale={{
            type: 'linear',
            min: lowestValue,
            max: 'auto',
            stacked: false,
            reverse: false,
          }}
          curve="monotoneX"
          axisTop={null}
          axisRight={null}
          xFormat={'time:%Y-%m-%d'}
          xScale={{
            type: 'time',
            format: '%Y-%m-%d',
            precision: 'day',
          }}
          axisBottom={{
            format: oldest_balance_age_in_months > 1 ? `%b '%y` : `%d %b`,
            orient: 'bottom',
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 90,
          }}
          // axisLeft={{ orient: 'left', legend: 'Bal' }}
          animate={false}
          tooltip={(props) => {
            return (
              <div className="px-2 py-1 text-xs text-white rounded bg-jcap-700">
                {props.point.data.y > 1000000 ? (
                  <div>
                    <p>
                      {new Date(props.point.data.x)
                        ?.toISOString()
                        .substring(0, 10)}
                    </p>
                    <p>{curr(Number(props.point.data.y) / SIGF, currency)}m</p>
                  </div>
                ) : (
                  <div>
                    <p>
                      {
                        new Date(props.point.data.x)
                          ?.toISOString()
                          .split('T')[0]
                      }
                    </p>
                    <p>{curr(Number(props.point.data.y), currency)}</p>
                  </div>
                )}
              </div>
            );
          }}
        />
      </div>
    </div>
  );
};

export default ChartBalanceHistory;
